import React from 'react';
import { PHONE_NUMBERS } from '../config';


export const locationPath = () => {
  const path = window.location.pathname.split( '/' )[1];
  if(path === ""){
    return 'listing-page';
  }else{
    return path + '-page';
  }
}


export const phoneNumber = (charSpace, ISOCurrencyCode) => {
  switch (ISOCurrencyCode) {
      case 'USD':
      case 'CAD':
          return charSpace ? PHONE_NUMBERS.USDCAD[0] : PHONE_NUMBERS.USDCAD[1];
      case 'GBP':
      case 'EUR':
          return charSpace ? PHONE_NUMBERS.GBPEUR[0] : PHONE_NUMBERS.GBPEUR[1];
      case 'AUD':
          return charSpace ? PHONE_NUMBERS.AUD[0] : PHONE_NUMBERS.AUD[1];
      case 'NZD':
          return charSpace ? PHONE_NUMBERS.NZD[0] : PHONE_NUMBERS.NZD[1];
      default:
          return charSpace ? PHONE_NUMBERS.USDCAD[0] : PHONE_NUMBERS.USDCAD[1];
  }
}


export const currentLocation = (ISOCurrencyCode) => {
  switch (ISOCurrencyCode) {
      case 'USD':
          return 'US';
      case 'CAD':
          return 'CA';
      case 'GBP':
          return 'UK';
      case 'EUR':
          return 'EUR';
      case 'AUD':
          return 'AU';
      case 'NZD':
          return 'NZ';
      case 'ZAR':
        return 'ZA';
      default:
          return 'US';
  }
}



export const ISOCurrencyCovert = (ISOCurrencyCode) => {
  switch (ISOCurrencyCode) {
    case "GBP": return <span>&#163;</span>;
    case "AUD": return <span>&#36;</span>;
    case "NZD": return <span>&#36;</span>;
    case "USD": return <span>&#36;</span>;
    case "CAD": return <span>&#36;</span>;
    case "ZAR": return <span>R</span>;
    case "EUR": return <span>&#8364;</span>;
    default: return <span>&#36;</span>;
  }
}

export const isoCovertNumber = (arr, value) =>{
  for(let i = 0; i < arr.length; i++){
    if(arr[i].iso_country_code === value){
      return arr[i].dialing_code;
    }
  }
}

export const isoCovertString = (arr, value) => {
  for(let i = 0; i < arr.length; i++){
    if(arr[i].iso_country_code === value){
      return arr[i].name;
    }
  }
}

export const isoNameConvert = (selectedValue, dropdownType, nationalityArr, nationalityStateArr) => {

  if(dropdownType === 'nationality' && nationalityArr !== undefined && nationalityArr.length > 0){
      for(let i=0; i < nationalityArr.length; i++){
        if(nationalityArr[i].iso_country_code === selectedValue){
          return nationalityArr[i].name;
        }
      }
  }

  if(dropdownType === 'nationalityState' && nationalityStateArr !== undefined && nationalityStateArr.length > 0){
    for(let j=0; j < nationalityStateArr.length; j++){
      if(nationalityStateArr[j].abbreviation === selectedValue){
        return nationalityStateArr[j].name;
      }
    }
  }

  if(dropdownType === 'phonePrefix' && nationalityArr !== undefined && nationalityArr.length > 0){
    for(let k=0; k < nationalityArr.length; k++){
      if(nationalityArr[k].iso_country_code === selectedValue){
        return nationalityArr[k].dialing_code;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/helpers/locationHelper.js